<div #webcamContainer class="webcam-container">
  @if (showWebcam && cameraHeight && cameraWidth) {
    <webcam
      [height]="cameraHeight"
      [width]="cameraWidth"
      [trigger]="trigger.asObservable()"
      [videoOptions]="videoOptions"
      [imageQuality]="1"
      [allowCameraSwitch]="false"
      (imageCapture)="handleImage($event)"
      (initError)="handleInitError($event)"
    ></webcam>
  }
  @if (!hideButton) {
    <button class="camera-button" (click)="triggerSnapshot()">
      <i class="fas fa-camera"></i>
    </button>
  }
</div>
